import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AddToDriveIcon(props: IconProps) {
    return <Icon {...props} iconKey={"add_to_drive"}/>
}
